import styled from "styled-components";

export const Container = styled.section`
  min-height: 400px;
`;

export const Description = styled.p`
  margin-top: 1rem;
  font-weight: 500;
  margin-top: 2.2rem;
`;

export const Subtitle = styled.p`
  font-weight: 600;
  margin-top: 2.2rem;
`;
